import React from "react";
import {
  Swords,
  CalendarCheck,
  PlayCircle,
  Sparkles,
  PenLine,
  ScanText,
  IdCard,
  Calculator,
  CalendarDays,
  GraduationCap,
  Users,
  Briefcase,
  ShieldCheck,
} from "lucide-react";
import Reveal from "../ui/Reveal";
import "../../styles/home-stories.css";

const built = [
  {
    icon: Swords,
    asked: "Students expected it",
    title: "Challenge a friend",
    text: "Students were looking for a way to go head-to-head with their friends, so we built challenges you start with a 6-digit code.",
  },
  {
    icon: CalendarCheck,
    asked: "Students loved it",
    title: "Daily test note and quiz",
    text: "A short note and a quiz each day. The feedback was so good that we built on it.",
  },
  {
    icon: PlayCircle,
    asked: "The next step",
    title: "Daily test video",
    text: "The latest addition: a short explainer video alongside the daily test, so you learn the answer, not just the score.",
  },
];

export function YouAskedWeBuilt() {
  return (
    <section className="section built-section">
      <div className="container">
        <Reveal>
          <div className="section-heading section-heading-center">
            <span className="eyebrow">Built with students</span>
            <h2 className="heading-2">You asked. We built it.</h2>
            <p className="body-large">
              CampusGenie is shaped by what students tell us. Here's how the features you'll see above came about.
            </p>
          </div>
        </Reveal>

        <div className="built-grid">
          {built.map(({ icon: Icon, asked, title, text }, i) => (
            <Reveal key={title} delay={i * 0.08}>
              <div className="built-card">
                <span className="built-icon">
                  <Icon size={20} />
                </span>
                <p className="built-asked">{asked}</p>
                <h3>{title}</h3>
                <p>{text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

const toolkit = [
  { icon: Sparkles, title: "AI study planner", text: "A schedule built around your weak areas." },
  { icon: PenLine, title: "AI writing tools", text: "Grammar checker, paraphraser, translator and summariser." },
  { icon: ScanText, title: "Question scanner", text: "Snap a question and get help with it." },
  { icon: Calculator, title: "GPA tracker", text: "Your CGPA across every semester, without the maths." },
  { icon: IdCard, title: "Digital student ID", text: "Your verified campus identity on your phone." },
  { icon: CalendarDays, title: "Academic calendar", text: "Lectures, exams and deadlines in one place." },
  { icon: GraduationCap, title: "Scholarship alerts", text: "Open scholarships and grants you may qualify for." },
  { icon: Briefcase, title: "Internships", text: "Discover opportunities and apply from the app." },
  { icon: Users, title: "Alumni mentors", text: "Advice and referrals from graduates in your field." },
  { icon: ShieldCheck, title: "Campus safety", text: "Safety resources when you need them." },
];

export function ToolkitGrid() {
  return (
    <section className="section section-alt toolkit-section">
      <div className="container">
        <Reveal>
          <div className="section-heading section-heading-center">
            <span className="eyebrow">And the rest of your toolkit</span>
            <h2 className="heading-2">Everything else a student ends up needing.</h2>
            <p className="body-large">One account that goes with you from JAMB prep to graduation.</p>
          </div>
        </Reveal>

        <div className="toolkit-grid">
          {toolkit.map(({ icon: Icon, title, text }, i) => (
            <Reveal key={title} delay={(i % 5) * 0.04}>
              <div className="toolkit-card">
                <span className="toolkit-icon">
                  <Icon size={18} />
                </span>
                <h4>{title}</h4>
                <p>{text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
